@if (apps == null) {
<div class="mt-[20%] mx-auto w-[60%]">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
}
@else {
<div>
    @for (details of apps; track details.AppID) {
    <div>
        <app-application-summary [details]="details"></app-application-summary>
    </div>
    }
</div>
}